import React from 'react'
import PropTypes from 'prop-types'
import {
  morningstarStarIconHelper,
  isPresented,
} from '../../Helpers/FundUtility.js'
import RatingsRiskEquityStyleBox from './RatingsRiskEquityStyleBox.jsx'
import { formatDateStandard } from '../../../../global/formatters/string-formatter.js'

function RatingsRiskMorningstarResearch({ fund, morningStarRatings }) {
  const mStarDetails = morningStarRatings.morningStarRatingDetails
  const morningStarDetailSubset = mStarDetails.slice(1, mStarDetails.length)

  return (
    <React.Fragment>
      <h3>
        Morningstar Research{' '}
        <span>as of {formatDateStandard(morningStarRatings.asOfDate)}</span>
      </h3>
      <div className="Grid">
        {isPresented(fund, 'morningStarRatingDetail') && (
          <div
            className="u-sizeFill u-marginRight8gu u-sm-flexAuto u-sm-marginRight0 u-sm-sizeFull"
            id="morningstar-rating"
          >
            <div className="Grid-striper Reverse-striper">
              <div className="Grid Grid--alignBottom Grid--fill Grid--withGutter u-paddingHoriz1gu u-paddingVert3gu u-sm-paddingTop0">
                <div className="u-sm-size6of12 u-sm-paddingTop3gu">
                  <h4>Overall Rating</h4>
                  <p className="u-textSizeMsrp3 u-textSecondary u-sm-paddingTop0 u-sm-textSizeMsrp1">
                    <span className="Icon u-textColorBrandLight u-textDefault u-textSizeMsrp2">
                      {morningstarStarIconHelper(mStarDetails[0].rating)}
                    </span>
                  </p>
                </div>
                {morningStarDetailSubset.map((category) => {
                  return (
                    <MorningstarResearchItem
                      key={category.interval}
                      label={category.interval}
                      fundValue={category.rating}
                      starRating={true}
                    />
                  )
                })}
              </div>
              <div className="Grid Grid--alignBottom Grid--fill Grid--withGutter u-paddingHoriz1gu u-paddingVert3gu u-sm-paddingTop0">
                <div className="u-sm-size6of12 u-sm-paddingTop3gu">
                  <h4>Percentile Ranking</h4>
                  <p className="u-textSizeMsrp3 u-textSecondary u-sm-paddingTop0 u-sm-textSizeMsrp1">
                    {mStarDetails[0].rank}
                  </p>
                </div>
                {morningStarDetailSubset.map((category) => {
                  return (
                    <MorningstarResearchItem
                      key={category.interval}
                      label={category.interval}
                      fundValue={category.rank}
                      postValueLabel="%"
                    />
                  )
                })}
              </div>
              <div className="Grid Grid--alignBottom Grid--fill Grid--withGutter u-paddingHoriz1gu u-paddingVert3gu u-sm-paddingTop0">
                <div className="u-sm-size6of12 u-sm-paddingTop3gu">
                  <h4>Total Funds in Category</h4>
                  <p className="u-textSizeMsrp3 u-textSecondary u-sm-paddingTop0 u-sm-textSizeMsrp1">
                    {mStarDetails[0].fund}
                  </p>
                </div>
                {morningStarDetailSubset.map((category) => {
                  return (
                    <MorningstarResearchItem
                      key={category.interval}
                      label={category.interval}
                      fundValue={category.fund}
                    />
                  )
                })}
              </div>
            </div>
          </div>
        )}
        {morningStarRatings.morningStarEquityStyleBox &&
          isPresented(fund, 'morningStarEquityStyleBox') && (
            <RatingsRiskEquityStyleBox
              mStarEquityBox={morningStarRatings.morningStarEquityStyleBox}
            />
          )}
      </div>
      <div className="disclaimer u-marginTop4gu">
        {isPresented(fund, 'morningStarRatingDetail') && (
          <p className="Disclaimer-text u-paddingBottom3gu">
            Star ratings based on a Morningstar risk-adjusted return measure.
            Percentile rankings based on average annual total returns (1 being
            most favorable, 100 being least).
          </p>
        )}
        <a
          className="u-textNormal u-textSolid u-textSecondary"
          href="#morningstar-disclosures"
        >
          View disclosures
        </a>
      </div>
    </React.Fragment>
  )
}

function MorningstarResearchItem({
  label,
  fundValue,
  postValueLabel,
  starRating,
}) {
  return (
    fundValue && (
      <div className="u-sm-size6of12 u-sm-paddingTop3gu">
        <p className="u-textColorLight u-textSecondary u-textSolid">{label}</p>
        <p className="u-textSizeMsrp3 u-textSecondary u-sm-paddingTop0 u-sm-textSizeMsrp1">
          {starRating === true ? (
            <span className="Icon u-textColorBrandLight u-textDefault u-textSizeMsrp2">
              {morningstarStarIconHelper(fundValue)}
            </span>
          ) : (
            <React.Fragment>
              {fundValue}
              {postValueLabel}
            </React.Fragment>
          )}
        </p>
      </div>
    )
  )
}

RatingsRiskMorningstarResearch.propTypes = {
  morningStarRatings: PropTypes.object.isRequired,
}

MorningstarResearchItem.propTypes = {
  label: PropTypes.string,
  fundValue: PropTypes.string,
  postValueLabel: PropTypes.string,
  starRating: PropTypes.bool,
}

export default RatingsRiskMorningstarResearch
